import { IS_PUBLIC_ALBUM } from 'reactApp/appHelpers/configHelpers';
import { isOwnPublic, isPublicUploadEnabled } from 'reactApp/modules/public/public.selectors';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { showSnackbarAction } from 'reactApp/modules/snackbar/snackbar.actions';
import { SnackbarTypes } from 'reactApp/modules/snackbar/snackbar.types';
import { isEmailAbsent } from 'reactApp/modules/socialUser/socialUser.selectors';
import { getStorageConfig } from 'reactApp/modules/storage/storage.config';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { ViewerSelectors } from 'reactApp/modules/viewer/viewer.selectors';
import { put, select } from 'redux-saga/effects';

export function* checkCanUpload() {
    const isNewbie = yield select(UserSelectors.isNewbie);
    const isAnonymous = yield select(UserSelectors.isAnonymous);
    const isSocial = yield select(UserSelectors.isSocialUser);
    const storage = yield select(getCurrentStorage);
    const isOwnFolder = yield select(isOwnPublic);
    const isEmailAbsentVal = yield select(isEmailAbsent);
    const isPublicUploadAllowed = yield select(isPublicUploadEnabled);
    const isViewerActive = yield select(ViewerSelectors.isViewerActive);

    const { isStart, isDocuments, isPublic, isHome, isGallery, isFeed, isFavorites, isAlbums } = getStorage(storage);
    const isStorageSupportsUpload =
        isStart || isDocuments || isHome || isGallery || isFeed || isFavorites || isAlbums || getStorageConfig(storage).add;
    const isOwn = isPublic ? isOwnFolder : false;
    const canUploadToPublic = isPublic ? isPublicUploadAllowed || isOwn : false;

    let result = true;

    if ((isSocial && isEmailAbsentVal && !isPublic) || isViewerActive || IS_PUBLIC_ALBUM) {
        result = false;
    }

    result = result && (isPublic || !isNewbie) && !isAnonymous && isStorageSupportsUpload && (isPublic ? canUploadToPublic : true);

    if (!result && isPublic) {
        let text = 'Вы можете только просматривать содержимое папки, загружать в нее нельзя';
        if (isAnonymous && isPublicUploadAllowed) {
            text = 'Только зарегистрированные пользователи могут загружать файлы в публичные папки.';
        }

        yield put(showSnackbarAction({ closable: true, id: 'uploaderror', type: SnackbarTypes.failure, text }));
    }

    return result;
}
